import {ref, unref, reactive} from 'vue'
import equal from 'fast-deep-equal'
import {ttype_by_id} from '@/tourist/tourist-store.js'
import {precalc as precalc_action} from '@/actions.js'
import {dmy2ymd} from './useOrder.js'

const a0tofloat = all => {
//console.log('a0tofloat', all)
    const entries = Object.entries(all).map( ([key, priceob] ) => {
        const newpriceob = {}
        newpriceob.v = price2float( priceob.v )
        // v - базовая цена 
        // comm абсолютная комиссия после авторизации 
        // pcomm - процент комисси
        // только морские
        for (let ff of ["tariff","dues", "comm"]) {
            newpriceob[ff] = priceob[ff] ? price2float( priceob[ff] ) : null
        }
        if ( priceob.comm ) {// процент комиссии для авторизованных
            newpriceob.pcomm = priceob.pcomm 
        }

        return [key, newpriceob]
    }  )
    const ret = Object.fromEntries( entries )
//console.log('a0tofloat ret', ret)    
    return ret
}
const price2float = ([a,b]) => [Number(a+'e-4'), b]

export const passengers_from_store = ({cstore, tstore, bookCabins}) => {
    let all = []
    cstore.getCabins.forEach( ({id,places}) => {
        const cabinGuests = places.map( place => {
            let rec 
            const personItem = bookCabins.personItem( id, place )
            let {sid} = unref(personItem)
            let {ttype} = place
            const passenger_type = ttype_by_id(ttype).status
            const cabin_id = id
            if (!sid) {
                let country = 'RU' // по умолчанию считаем так
                rec = {cabin_id, passenger_type, country}
            } else {
                const person = tstore.person(sid)
                let country = person.doc_gra.val
                let birthday = tstore.field_isValid(person, 'born') ? dmy2ymd(person.born.val) : ''
                let male = person.male.val
                rec = {cabin_id, passenger_type, country, birthday, male}
            }
            return rec
        } )
        all = all.concat( cabinGuests )
    } )
    return all
}

const precalc_item = ({cruiseIdFull, key, target}) => {
    const current = reactive({
        params: null,
        epoch: 0,
        wait: false,
        ok: false,

        calc_prices: null,
        src: null,
        acc: null, 
        acc_message: '',

        error: 'Ожидайте',
    })

    const epoch = ref(0)

    const fetch_precalc = params => {
        current.params = params
        epoch.value = Date.now()
        current.wait = true
        current.ok = false
        precalc_action( params ).then( resolve => proc( {resolve}),  reject => proc( {reject})  )
    }

    const proc = ({resolve, reject}) => {
        if (epoch.value > current.epoch) {// пропускаем незаконченные TODO: делать abort
            if (resolve) {
                current.wait = false
                current.ok = true

                const {calc_prices,src, acc, acc_message} = resolve
                current.calc_prices = acc ? a0tofloat(calc_prices) : {}
                current.src = src
                current.acc = acc
                current.acc_message = acc_message
            } else {
                current.wait = false
                current.ok = false

                current.error = reject.toString()
            }
            current.epoch = epoch.value
        }
    }

    const set_cabinOccupation = ({cabinId, places}) => {
        const passengers = places.map(({ttype}) => {
            const passenger_type = ttype_by_id(ttype).status
            const cabin_id = cabinId
            const country = 'RU' // по умолчанию считаем так
            return {
                passenger_type, cabin_id, country
            }
        })
        const params = {  passengers, cruiseIdFull, key   }
        const {params: paramsCur, wait, ok} = unref(current)
        if ((!wait && !ok) || !equal(params, paramsCur)) {// страховка от дублирующих вызов
            fetch_precalc( params )
        }
    }

    const set_bookCabins = stores => {// 
        const passengers = passengers_from_store( stores )
        const params = {  passengers, cruiseIdFull, key   }
        const {params: paramsCur, wait, ok} = unref(current)
        if ((!wait && !ok) || !equal(params, paramsCur)) {// страховка от дублирующих вызов
            fetch_precalc( params )
        }
    }


    const get = () => {
        return current
    }

    return {
        get, set_cabinOccupation, set_bookCabins, 
    }
}


export const precalc = ({cruiseIdFull, key, target}) => {
    return precalc_item({cruiseIdFull, key, target})
}

